import { Injectable, OnDestroy } from '@angular/core';
import { environment } from '../../../../../../environments/environment';
import { getCurrentAccessToken } from 'polly-commons';

@Injectable({
  providedIn: 'root',
})
export class TabCloseService implements OnDestroy {
  private readonly reloadKey = 'pendingReload';
  private workspaceId?: string;
  private analysisId?: string | number;
  private sessionId?: string;
  private readonly apiBaseUrl = environment.baseApi;  

  constructor() {
    this.setupListeners();
  }

  /**
   * Initialize session details (call this when user/session starts)
   */
  public initSession(workspaceId: string, analysisId: string | number, sessionId: string): void {
    this.workspaceId = workspaceId;
    this.analysisId = analysisId;
    this.sessionId = sessionId;
  }

  private setupListeners(): void {
     // Explicitly bind this to keep service context
    window.addEventListener('beforeunload', this.beforeUnloadHandler.bind(this));
    window.addEventListener('DOMContentLoaded', this.onPageLoad.bind(this));
  }

  private beforeUnloadHandler(_event: BeforeUnloadEvent): void {
    if (!this.workspaceId || !this.analysisId || !this.sessionId) return;
    sessionStorage.setItem(this.reloadKey, '1');
    this.closeApplicationRunningInstance();
  };

  public closeApplicationRunningInstance(): void {
    if (!this.workspaceId || !this.analysisId || !this.sessionId) return;
    const apiUrl = `${this.apiBaseUrl}/compute/${this.workspaceId}/analysis/${this.analysisId}?session=${this.sessionId}`;

    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/vnd.api+json');
    myHeaders.append('authorization', 'Bearer ' + getCurrentAccessToken());

    const requestOptions: RequestInit = {
      method: 'DELETE',
      headers: myHeaders,
      keepalive: true,
    };

    fetch(apiUrl, requestOptions)
      .then((response) => response.text())
      .then((result) => console.log(result))
      .catch((error) => console.error(error));
  }

  private onPageLoad(): void {
    if (sessionStorage.getItem(this.reloadKey)) {
      sessionStorage.removeItem(this.reloadKey);
    }
  };

  public removeListeners(): void {
    window.removeEventListener('beforeunload', this.beforeUnloadHandler);
    window.removeEventListener('DOMContentLoaded', this.onPageLoad);
  }

  public ngOnDestroy(): void {
    this.removeListeners();
  }
}
